import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';


import store from "./app/store";
import i18n from './app/i18n';
import SuspenseContent from "./modules/containers/SuspenseContent";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Suspense fallback={<SuspenseContent />}>
    <Provider store={store}>
      <I18nextProvider i18n={i18n} defaultNS={'common'}>
        <App />
      </I18nextProvider>
    </Provider>
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
